import {
  ajax
} from 'application/src/js/functions.js';
import {
  Mediator
} from 'application/src/js/util';

/**
 * @description modal for sending an answer to the person who sent an offer for a request
 * @param {ModalWindow} args.modal ModalWindow instance
 * @param {SpinnerOverlay} args.loader SpinnerOverlay instance
 */
export default class AnswerOfferModal extends Mediator {
  constructor(args) {
    super(args);
    this.modal = args.modal;
    this.loader = args.loader;

    this.saveButton = this.modal.element.querySelectorAll('.save-button');
    this.openButton = document.querySelectorAll('.open-send-answer-modal');

    this.requestOfferId = null;
    this.debugMode = true;

    this.addEvents();
  }

  addEvents() {
    [...this.openButton].map(button => {
      button.addEventListener('click', e => {
        this.requestOfferId = e.target.getAttribute('data-request-offer-id');
        this.modal.open();
      });
    });

    [...this.saveButton].map(button => {
      button.addEventListener('click', _ => {
        const notice = document.querySelector('#notice').value;
        const checkState = document.querySelector('#check_state option:checked').value;

        if (notice.length && checkState.length) {
          this.loader.show();

          ajax('/mundus-agri/offer/contactOfferOwner', {
            request_offer_id: this.requestOfferId,
            check_state: checkState,
            notice: notice
          }).then(response => {
            if (response.data) {
              this.modal.close();
              location.reload(true);
              document.getElementById("request-offers").scrollIntoView();
            }
            this.loader.hide();
          }).catch(e => {
            if (this.debugMode) console.log(e);
            this.loader.hide();
          });
        }
      });
    });
  }
}